document.addEventListener('DOMContentLoaded', function () {

    $('.article__content img').each(function() {
        const $img = $(this);
        const src = $img.attr('src');
        console.log('$img$img$img', $img)
        if (!src) return;
        const fileName = src.split('/').pop().split('?')[0];

        $img.attr('alt', fileName);
    })
    $('.p-upsell__check-label').click(function() {
        $(this).toggleClass('active');
        $('.p-upsell__options-wrap').slideToggle();
        updatePriceWithUpsell();
    })
    $('.p-upsell__fit').click(function(e) {
        e.preventDefault();
        $('#FitGuideModal').toggleClass('modal--is-active modal-open')
    })
    $('.p-upsell__option-value').click(function(e) {
        $(this).siblings('.p-upsell__option-value').removeClass('active');
        $(this).addClass('active');
        if($(this).hasClass('p-upsell__option-value--color')) {
            $('[data-upsell-color] span').html(` ${$(this).attr('data-value')}`)
        }
        initUpsellOptions();
        updatePriceWithUpsell();
    })

    initUpsellOptions();

    function initUpsellOptions() {
        let size = $('.p-upsell__option-value--size.active').attr('data-value');
        let color = $('.p-upsell__option-value--color.active').attr('data-value');
        let img = null;
        let price = null;
        let comparePrice = null;
        let select = $('#pUpsellSelect');
        $('.p-upsell__option-value--size').removeClass('disabled');
        select.find(`option[data-color="${color}"]`).each(function() {
            img = $(this).attr('data-image');
            price = $(this).attr('data-price');
            comparePrice = $(this).attr('data-compare-price');
            let s = $(this).attr('data-size');
            if($(this).attr('data-available') === 'false') {
                $(`.p-upsell__option-value--size[data-value="${s}"]`).addClass('disabled');
            }
        })
        $('.p-upsell__img img').attr('src', img)
        $('.p-upsell__price [data-price]').html(price);
    
        if(price) {
            $('.p-upsell__price').attr('data-price', price.replace('$', ''));
        }

        if(comparePrice) {
            $('.p-upsell__price').attr('data-compare-price', comparePrice.replace('$', ''));
        }

        if(comparePrice !== price) {
            $('.p-upsell__price [data-compare-price]').html(comparePrice).show();
        } else {
            $('.p-upsell__price [data-compare-price]').hide();
        }
    }

    $('.page-content .variant__button-label[data-linked-upsell]').click(function() {
        console.log('ggs')
        $(`.p-upsell__option-value[data-value="${$(this).attr('data-linked-upsell')}"]`).click();
    })
    $('.variant__button-label.variant__button-size').click(function() {
        let size = $(this).html();
        $(this).closest('.product__meta').find(`.p-upsell__option-value[data-value="${size}"]`).click();
    })

    window.updatePriceWithUpsell = function() {
        let price = '.cart-gwp .product__price-final',
            comparePrice = '.main-content .product__price--compare',
            upsellPrice = '.p-upsell__price';
        let initPrice = $(price).attr('data-price');
        let initComparePrice = $(comparePrice).attr('data-compare-price');
        let uPrice = +$(upsellPrice).attr('data-price')
        let uComparePrice = +$(upsellPrice).attr('data-compare-price')
        if($('.p-upsell__check-label.active').length) {
            $(price).html(`$${+initPrice.replace('$', '') + uPrice}`)
            $(comparePrice).html(`$${+initComparePrice.replace('$', '') + uComparePrice}`)
        } else {
            $(price).html(initPrice)
            $(comparePrice).html(initComparePrice)
        }
    }
    $('.color-swatch--small').click(function() {
        $(this).closest('.c-product').find('.grid-product__tag--variant').remove();
        let sale = $(this).attr('data-final-sale')
        if(sale) {
            $(this).closest('.c-product').find('.grid-product__tag').hide();
            $(this).closest('.c-product').find('.grid-product__content').append(`<div class="grid-product__tag grid-product__tag--variant">${sale}</div>`)
        } else {
            $(this).closest('.c-product').find('.grid-product__tag').show();
        }
    })
});